import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="live-event-settings-accordion"
export default class extends Controller {
  static targets = [ "panel", "chevron", "icon" ]

  isOpen = false

  panelTargetConnected() { this.applyState() }
  chevronTargetConnected() { this.applyState() }
  iconTargetConnected() { this.applyState() }

  toggle(event) {
    event.preventDefault()
    this.isOpen = !this.isOpen
    this.applyState()
  }

  applyState() {
    this.panelTargets.forEach(panel => {
      panel.classList.toggle("max-h-2000", this.isOpen)
      panel.classList.toggle("max-h-0", !this.isOpen)
    })

    if (this.hasChevronTarget) {
      this.chevronTarget.setAttribute("aria-expanded", this.isOpen ? "true" : "false")
    }

    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("rotate-180", this.isOpen)
    }
  }
}
